import request from './axios';

export async function txGetRequest(url, config) {
    let ret
    if (!config) {
        config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    }
    ret = await request.get(url, config)
    return ret.data
}

export async function txPostRequest(url,params={}, config) {
    let ret
    if (!config) {
        config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    }
    ret = await request.post(url,params, config)
    return ret.data
}